// extracted by mini-css-extract-plugin
export default {"virtual-border":"JyBZ7S13oB0xxImQJXdx","common_bganimation":"TUUY1ZiApcPBVmDmsDm4"};